type DatafastParams = Record<string, string>

declare global {
  interface Window {
    datafast?: (goal: string, params?: DatafastParams) => void
  }
}

/**
 * Datafast custom goals (guides/28). Goal names: lowercase letters, numbers,
 * _ - : only, max 64 chars. Param values max 255 chars, max 10 params.
 * Safe no-op during SSR and when the tracking script is blocked.
 */
export function useDatafast() {
  function trackGoal(goal: string, params?: DatafastParams) {
    if (import.meta.server) return
    try {
      window.datafast?.(goal, params)
    } catch {
      // Analytics must never break the app
    }
  }

  return { trackGoal }
}
